module.exports = __webpack_public_path__ + "static/media/Drug_Help_MAT_v6.b15f5e89.mp4";